import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { ClientLpAction } from '@cbridge-packages/lp-client';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';

export const onUpdateClientLpToggleEditEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    ClientLpAction.update.done,
  ),
  mergeMap(() => {
    return [
      DetailsSidebarAction.toggleEdit(),
      ClientLpAction.loadList.started(),
    ];
  }),
);
